var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemReferralInactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C8.89543 18 8 18.8954 8 20V26C8 27.1046 8.89543 28 10 28H14V18H10ZM14 30H12V38C12 38.5523 12.4477 39 13 39C13.5523 39 14 38.5523 14 38V30ZM10 30C7.79086 30 6 28.2091 6 26V20C6 17.7909 7.79086 16 10 16H15C15.5523 16 16 16.4477 16 17V38C16 39.6569 14.6569 41 13 41C11.3431 41 10 39.6569 10 38V30Z",
    fill: "#171717",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4812 7.12339C30.8012 7.29903 31 7.63502 31 8V18C33.2091 18 35 19.7909 35 22V23C35 25.2091 33.2091 27 31 27V37C31 37.365 30.8012 37.701 30.4812 37.8766C30.1613 38.0522 29.771 38.0396 29.4631 37.8437L18.4631 30.8437C18.1747 30.6601 18 30.3419 18 30V15C18 14.6581 18.1747 14.3399 18.4631 14.1563L29.4631 7.15634C29.771 6.96039 30.1613 6.94776 30.4812 7.12339ZM31 25C32.1046 25 33 24.1046 33 23V22C33 20.8954 32.1046 20 31 20V25ZM20 15.5489V29.4511L29 35.1783V9.82167L20 15.5489Z",
    fill: "#171717",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemReferralInactiveIcon);
export default __webpack_public_path__ + "static/media/system-referral-inactive-icon.7c05c1a78dc248085185207dcae65841.svg";
export { ForwardRef as ReactComponent };